export const CARE_FAKEDOOR_MODAL_TEXTS = {
  unavailableFeature: {
    title: 'Agradecemos pelo seu interesse!',
    description:
      'Essa funcionalidade ainda não está ativa, mas em breve ela estará disponível.',
    question: 'Gostaria de receber um aviso quando ela for lançada?',
    actions: {
      primary: 'Sim, me avise',
      negative: 'Agora não',
    },
  },
  sendFeedback: {
    alert: {
      title:
        'Tudo certo! Te avisaremos por e-mail e pelo app assim que a novidade chegar.',
    },
    title: 'Sua experiência pode nos ajudar!',
    description:
      'Você sentiu falta de alguma outra função para organizar seus cuidados de saúde?',
    description2:
      'Sua resposta é opcional, mas faz toda a diferença pra gente.',
    placeholder: 'Digite aqui',
    actions: {
      primary: 'Enviar',
      negative: 'Fechar',
    },
  },
  sendedFeedback: {
    title: 'Agradecemos por participar!',
    description: 'Sua opinião é essencial para evoluirmos o nosso produto.',
    actions: {
      negative: 'Fechar',
    },
  },
  errors: {
    notification:
      'Erro ao enviar pedido de notificação, tente novamente mais tarde',
    feedback: 'Erro ao enviar feedback, tente novamente mais tarde',
  },
}
